<template>
<v-layout>
  
  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
      color="amber darken-4"
      dark
      >
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  
  <v-col offset-md="1" md="10">
    
    <v-container grid-list-xl text-center>
      <v-layout wrap>
	<v-flex md8>
	  
          <v-card dark color="amber darken-4" class="elevation-10">
            <v-card-text>
              <span class="display-1 font-weight-medium">Weasel collection status </span>
              <br/>
              <span class="display-1 font-weight-thin">@ {{ report.reportdate }}</span>
            </v-card-text>
          </v-card>
	  
          <br/>
	  
	  
	</v-flex>
	<v-flex md4>
	  
          <v-date-picker
            class="elevation-10"
            style="margin: 0"
            :reactive="reactive"
            v-model="wantedReportDate"
            color="amber darken-4"
            ></v-date-picker>
	  
	</v-flex>
      </v-layout>
    </v-container>
    
    <v-container text-center v-if="errorState">
      <v-card
	max-width="500"
	class="mx-auto"
	color="red"
	>
	<v-card-text>
          <span class="display-1 font-weight-medium">No data for this date</span>
          <br/>
          <br/>
          <v-icon>fa-exclamation</v-icon>
	</v-card-text>
      </v-card>
    </v-container>
    
    
    <v-card v-else>
      <v-card-title>
	Only missing
	<v-spacer></v-spacer>
	<v-text-field
          v-model="search"
          append-icon="fa-search"
          label="Search"
          single-line
	  color="red"
          hide-details
	  ></v-text-field>
      </v-card-title>
      
      <v-card-text>
	<v-data-table
	  :headers="headers"
	  :items="report.stats"
	  :disable-pagination="booltrue"
	  :hide-default-footer="booltrue"
	  :search="search"
	  >

	  <template v-slot:item.irregular="{ item }">
	    <v-container>
	          <v-icon v-if="item.irregular" color="error">fa-check</v-icon>
	          <v-icon v-else color="success">fa-times</v-icon>
	    </v-container>
	  </template>
	  
	  <template v-slot:item.current_records="{ item }">
	    <v-container>
	      <v-btn class="ma-2" :color="item.records_color">{{ item.current_records }}</v-btn>
	    </v-container>
	  </template>
	  
	  <template v-slot:item.current_points="{ item }">
	    <v-container>
	      <v-btn class="ma-2" :color="item.points_color">{{ item.current_points }}</v-btn>
	    </v-container>
	  </template>
	  
	</v-data-table>
      </v-card-text>
    </v-card>
    
    
    
  </v-col>
  
</v-layout>
</template>

<script>
import { config } from '../config';

import Indicator from './Indicator.vue';

export default {
    components: {
	Indicator
    },
    data: () => ({
        reactive: true,
        loading: true,
        fixedHeader: true,
        report: {},
        errorState: false,
        wantedReportDate: new Date().toISOString().substr(0, 10),
	booltrue: true,
	search: '',
	headers: [
            { text: 'Collection name', value: 'name' },
            { text: 'Expected points', value: 'needed_points' },
            { text: 'Current points', value: 'current_points' },
            { text: 'Expected records', value: 'needed_records' },
            { text: 'Current records', value: 'current_records' },
            { text: 'Irregular', value: 'irregular' },
            { text: 'Offset', value: 'offset' },
	],
    }),
    
    watch: {
	
        wantedReportDate() {
            this.timer = 0;
            this.refreshRate = 0;
            this.loadData();
        },
    },
    
    created() {
        this.loadData();
    },
    
    methods: {
        loadData() {
            this.loading = true;
	    
            const url = `${config.baseUrl}weasel/status/${this.wantedReportDate}`;
	    
            this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
                this.report = res.data;	
                this.loading = false;
                this.errorState = false;
		
            }).catch((err) => {
		console.log(err);
                this.errorState = true;
                this.loading = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
